import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSpeedmap = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	x: 0,
	y: 0,
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		d: "M56.1 89.3c-2.6-.3-5.2-.7-7.7-1.4-5.7-1.6-10.8-4.4-15.3-8.3-1.5-1.3-1.7-3.5-.5-4.9 1.2-1.5 3.4-1.7 5-.4 3.1 2.6 6.6 4.8 10.4 6.1 18.9 6.7 38.9-4.9 42.7-24.1 2.8-14.3-3.8-28-16.6-35-11.2-6.1-26.1-4.5-35.8 3.8-.7.6-1.5 1.3-2.5 1.4-1.6.2-3-.6-3.7-1.9-.7-1.4-.3-3.1.9-4.2 3.6-3.1 7.6-5.7 12.1-7.2 15.6-5.3 29.6-2.4 41.6 9 6.5 6.2 10.2 14 11.3 23 .1 1 .2 1.9.3 2.9v3.8c0 .2-.1.5-.1.7-.3 5.7-1.9 11.1-4.7 16.1-5.3 9.5-13.1 15.9-23.6 19-2.6.8-5.3 1.1-8 1.5-1.9.1-3.8.1-5.8.1",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M53.7 39.3v-8.7c0-2.1 1.3-3.6 3.2-3.7 2-.1 3.5 1.2 3.7 3.3.1 1.9.1 3.8.1 5.8v9.6c0 .9.3 1.6.9 2.3 4.1 4.1 8.2 8.1 12.3 12.2 2 2 1.1 5.2-1.6 5.9-1.4.4-2.6-.2-3.6-1.2L56.6 52.7c-.5-.5-1-1.1-1.6-1.6-1-.9-1.4-1.9-1.4-3.3.1-2.8.1-5.7.1-8.5m-35.1-8.4h13.3c2 0 3.5 1.4 3.6 3.3.1 1.8-1.2 3.3-3.1 3.6-.4.1-.9.1-1.4.1H5.3c-2.1-.1-3.7-1.6-3.7-3.5 0-2 1.6-3.4 3.8-3.5zm9 38.3H14.3c-1.5 0-2.6-.7-3.3-2-.6-1.3-.4-2.5.4-3.6s2-1.4 3.3-1.4h25.8c1.9 0 3.3.9 3.8 2.4.8 2.3-.9 4.5-3.5 4.6zm-4.5-15.7H9.5c-1.7 0-3.1-1.3-3.3-2.9-.2-1.9.8-3.4 2.4-3.9.4-.1.8-.1 1.2-.1h26.4c2.2 0 3.7 1.4 3.7 3.4 0 2.1-1.5 3.5-3.8 3.5z",
		fill: "currentColor"
	})] })
});
export { SvgIconSpeedmap as ReactComponent };
